import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Route, Redirect, withRouter } from 'react-router-dom'

import { getIsAuthenticated } from 'containers/app/selectors'

const PrivateRoute = ({ isAuthenticated, component: Component, ...rest }) => {
  if (isAuthenticated === null) {
    return null
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  location: PropTypes.object,
}

const mapStateToProps = (state) => ({
  isAuthenticated: getIsAuthenticated(state),
})

const withConnect = connect(mapStateToProps)

export default compose(withRouter, withConnect)(PrivateRoute)
